// extracted by mini-css-extract-plugin
export default {"hamburgerMenu":"HmbMenu_hamburgerMenu__Iogir","isActive":"HmbMenu_isActive__fXIXb","hmbBtn":"HmbMenu_hmbBtn__8GdQF"};